import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Subject } from 'rxjs';

const languages = [
  'it',
  'en'
];

const defaultLanguage = 'en';
const defaultPath = 'en/home';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  language = defaultLanguage;
  private currentPageSub = new Subject<string>();
  currentPage = this.currentPageSub.asObservable();

  constructor(private router: Router) {
    const pages = router.config
      .map(r => r.path.replace(':l/', ''))
      .filter(p => p);

    router.events.subscribe(e => {
      if (e instanceof NavigationEnd) {
        const url = this.router.parseUrl(e.url).root.children.primary;
        const lang = url && url.segments[0].path;
        const page = url && url.segments[1].path;

        if (languages.includes(lang)) {
          this.language = lang;
        } else {
          this.language = defaultLanguage;
          this.router.navigateByUrl(defaultPath);
        }

        if (pages.includes(page)) {
          this.currentPageSub.next(page);
        } else {
          this.currentPageSub.next('home');
          this.router.navigateByUrl(defaultPath);
        }
      }
    });
  }
}
